import type { ElementType } from 'react';

import Box from '../Box';
import Button, { Props as ButtonProps } from '../Button';
import { styled } from '../styles';
import Typography from '../Typography';

export type SeeMoreProps = {
  isLoading?: boolean;
  shouldHideButton?: boolean;
  shouldShowResultCount?: boolean;
  rootComponent?: ElementType;
  onClick?: () => void;
  translations?: {
    seeMore: string;
    totalResults: string;
  };
  buttonProps?: ButtonProps;
};

const Root = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.text.secondary,
  paddingBottom: 0,
  width: '100%',
  minWidth: 250,
}));

function SeeMore({
  isLoading = false,
  shouldHideButton = false,
  rootComponent: RootComponent = 'div',
  shouldShowResultCount = false,
  onClick,
  translations = {
    seeMore: 'See more',
    totalResults: 'X out of Y',
  },
  buttonProps = {},
}: SeeMoreProps) {
  return (
    <Root component={RootComponent}>
      {(isLoading || !shouldHideButton) && (
        <Button onClick={onClick} variant="tertiary" isLoading={isLoading} {...buttonProps}>
          {translations.seeMore}
        </Button>
      )}

      {shouldShowResultCount && (
        <Typography sx={{ marginLeft: 'auto' }} variant="bodySmall">
          {translations.totalResults}
        </Typography>
      )}
    </Root>
  );
}

export default SeeMore;
